import { render } from "./MakePage.vue?vue&type=template&id=4753a396&scoped=true"
import script from "./MakePage.vue?vue&type=script&lang=js"
export * from "./MakePage.vue?vue&type=script&lang=js"

import "./MakePage.vue?vue&type=style&index=0&id=4753a396&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4753a396"]])

export default __exports__